import {
  getInfoFromOffer,
  Offer,
  OfferProperty
} from "@/services/offer/offer_handle";
import { PayWay } from "@/services/payment/types";

export const getIapPrice = (offer: Offer) => {
  try {
    return getInfoFromOffer(offer);
  } catch (e) {
    return "";
  }
};

export const getIapEffect = (offer: Offer) => {
  try {
    return getInfoFromOffer(offer, PayWay.iap, OfferProperty.effect);
  } catch (e) {
    return "";
  }
};

export const getIapProductId = (offer: Offer): string | undefined => {
  try {
    return getInfoFromOffer(offer, PayWay.iap, OfferProperty.product_id);
  } catch (e) {
    return "";
  }
};
